<style lang="less">
</style>
<template>
  <div>
    <Drawer
      :closable="false"
      placement="right"
      v-model="drawerVisible"
      width="60%"
      :title="drawerTitle"
    >
      <Row>
        <Col>
          <Card shadow="false">
            <Row>
              <Form
                ref="liveForm"
                :model="form"
                :label-width="70"
                :rules="formValidate"
                style="position: relative"
              >
                <FormItem label="直播场景" prop="liveTitle">
                  <Select
                    v-model="form.scene"
                    placeholder="请选择直播场景"
                    clearable
                    style="width: 200px"
                  >
                    <Option value="alone">活动拍摄</Option>
                    <Option value="ppt">三分屏</Option>
                    <Option value="topclass">大班课</Option>
                  </Select>
                </FormItem>
                <FormItem label="课程标题" prop="liveTitle">
                  <Input v-model="form.liveTitle" style="width: 600px" />
                </FormItem>
                <FormItem label="课程介绍" prop="liveContent">
                  <div ref="editor"></div>
                </FormItem>
                <Form-item label class="br">
                  <Button @click="editHTML" icon="ios-create-outline"
                    >编辑HTML代码</Button
                  >
                  <Button @click="fullscreenModal = true" icon="md-eye"
                    >预览</Button
                  >
                </Form-item>
                <FormItem label="报名费" prop="regFee">
                  <InputNumber
                    style="width: 150px"
                    :min="0"
                    v-model="form.regFee"
                  ></InputNumber>
                </FormItem>
                <FormItem label="直播时间" prop="liveTime">
                  <DatePicker
                    type="datetime"
                    @on-change="dataChange"
                    :value="form.liveTime"
                    format="yyyy-MM-dd HH:mm"
                    placeholder="请选择开播时间"
                    style="width: 200px"
                  ></DatePicker>
                </FormItem>
                <FormItem label="封面图" prop="liveImage">
                  <upload-input
                    :fileUrl="form.liveImage"
                    fileSize="400"
                    fileWh="750*566"
                    @on-change="handleUpload"
                    width="400px"
                    ref="upload"
                  ></upload-input>
                </FormItem>
                <FormItem label="频道ID" prop="channelId">
                  <Input
                    v-model="form.channelId"
                    style="width: 600px"
                    placeholder="请复制保利威后台直播间ID"
                  />
                </FormItem>
                <FormItem label="选择讲师" prop="lecturerId">
                  <user-choose
                    buttonText="选择讲师"
                    :userType="userType"
                    @on-change="handleSelectUser"
                    ref="user"
                  ></user-choose>
                </FormItem>
                <Form-item class="br">
                  <Button
                    type="primary"
                    :loading="submitLoading"
                    @click="handelSubmit"
                    style="width: 100px"
                    >提交</Button
                  >
                  <Button @click="handelCancel">取消</Button>
                </Form-item>
                <Spin size="large" fix v-if="loading"></Spin>
              </Form>
            </Row>
          </Card>
        </Col>
      </Row>
      <!-- html编辑 -->
      <Modal
        title="编辑html代码"
        v-model="showHTMLModal"
        :mask-closable="false"
        :width="900"
        :fullscreen="full"
      >
        <Input
          v-if="!full"
          v-model="dataEdit"
          :autosize="true"
          type="textarea"
          style="max-height: 60vh; overflow: auto"
        />
        <Input
          v-if="full"
          v-model="dataEdit"
          :autosize="true"
          type="textarea"
        />
        <div slot="footer">
          <Button @click="full = !full" icon="md-expand">全屏开/关</Button>
          <Button
            @click="editHTMLOk"
            type="primary"
            icon="md-checkmark-circle-outline"
            >确定保存</Button
          >
        </div>
      </Modal>
      <Modal title="预览" v-model="fullscreenModal" fullscreen>
        <div v-html="form.courseContent">{{ form.courseContent }}</div>
        <div slot="footer">
          <Button @click="fullscreenModal = false">关闭</Button>
        </div>
      </Modal>
    </Drawer>
  </div>
</template>
<script>
import { uploadFile } from "@/api/index";
import { addLive, editLive, getLive } from "@/api/bus";
import userChoose from "../../my-components/flyme/user-choose";
import uploadInput from "@/views/my-components/flyme/upload-input";
import E from "wangeditor";
// 表情包配置 自定义表情可在该js文件中统一修改
import { sina } from "@/libs/emoji";

let editor = null;
var xss = require("xss");
export default {
  name: "live-drawer",
  components: {
    userChoose,
    uploadInput,
  },
  data() {
    return {
      type: 0,
      userType: "UT_LECTURER",
      loading: false, // 表单加载状态
      selectUsers: [],
      drawerTitle: "添加课程",
      drawerVisible: false,
      form: {
        liveTitle: "",
        liveContent: "",
        lecturerId: "",
        isVipFree: "1",
        channelId: "",
        scene: "alone",
        liveTime: "",
        liveImage: "",
        regFee: 0,
      },
      formValidate: {
        liveTitle: [
          { required: true, message: "课程名称不能为空", trigger: "blur" },
        ],
        liveTime: [
          { required: true, message: "直播时间不能为空", trigger: "blur" },
        ],
        liveImage: [
          { required: true, message: "封面图不能为空", trigger: "blur" },
        ],
        liveContent: [
          { required: true, message: "课程介绍不能为空", trigger: "blur" },
        ],
      },
      submitLoading: false, // 添加或编辑提交状态
      dataEdit: "", // 编辑数据
      showHTMLModal: false, // 显示html
      full: false, // html全屏开关
      fullscreenModal: false, // 显示全屏预览
    };
  },
  methods: {
    init() {
      this.initEditor();
    },
    showDrawer(params) {
      if (params.id) {
        this.type = 1;
        this.drawerTitle = "编辑直播";
        this.form.id = params.id;
        this.getData();
      } else {
        this.$refs.liveForm.resetFields();
        this.$refs.upload.setPicUrl("");
        editor.txt.html("");
        this.drawerTitle = "添加直播";
        this.type = 0;
      }
      this.drawerVisible = true;
    },
    //打开用户选择
    showUserChooseDrawer() {
      this.$refs.user.showDrawer();
    },
    clearUser() {
      this.$refs.user.clearSelectUser();
    },
    initEditor() {
      let that = this;
      editor = new E(this.$refs.editor);
      let editorConfig = editor.customConfig
        ? editor.customConfig
        : editor.config;
      editorConfig.onchange = (html) => {
        this.form.liveContent = html;
      };
      editorConfig.uploadImgServer = uploadFile;
      editorConfig.uploadImgHeaders = {
        Authorization: that.getStore("accessToken"),
      };
      editorConfig.uploadFileName = "file";
      editorConfig.uploadImgHooks = {
        before: function (xhr, editor, files) {},
        success: function (xhr, editor, result) {},
        fail: function (xhr, editor, result) {
          that.$Message.error("上传图片失败");
        },
        error: function (xhr, editor) {
          that.$Message.error("上传图片出错");
        },
        timeout: function (xhr, editor) {
          that.$Message.error("上传图片超时");
        },
        customInsert: function (insertImg, result, editor) {
          if (result.status === true) {
            let url = result.data.fileUrl;
            insertImg(url);
            that.$Message.success("上传图片成功");
          } else {
            that.$Message.error(result.info);
          }
        },
      };
      editorConfig.fontNames = ["微软雅黑", "宋体", "黑体", "Arial"];
      editorConfig.emotions = [
        {
          title: "新浪",
          type: "image",
          content: sina,
        },
      ];
      editor.create();
    },
    editHTML() {
      this.dataEdit = this.form.liveContent;
      this.showHTMLModal = true;
    },
    editHTMLOk() {
      editor.txt.html(this.dataEdit);
      this.form.liveContent = xss(this.dataEdit);
      this.showHTMLModal = false;
    },
    getData() {
      this.loading = true;
      getLive(this.form.id).then((res) => {
        this.loading = false;

        if (res.status === true) {
          this.form = res.data;
          if (res.data.liveContent == "<p><br></p>") {
            this.form.liveContent = "";
          }
          editor.txt.html(this.form.liveContent);
          this.$refs.user.getUserChosed(res.data.users);
          this.$refs.upload.setPicUrl(this.form.liveImage);
        }
      });
    },
    dataChange(data1, data2) {
      this.form.liveTime = data1;
    },
    handelSubmit() {
      this.$refs.liveForm.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          if (this.type === 0) {
            // 添加 避免编辑后传入id等数据 记得删除
            delete this.form.id;
            // 用户id数据
            let ids = [];
            this.selectUsers.forEach((e) => {
              ids.push(e.id);
            });
            this.form.lecturerId = ids;
            addLive(this.form).then((res) => {
              this.submitLoading = false;
              if (res.status === true) {
                this.$Message.success("操作成功");
                this.$parent.getDataList();
                this.drawerVisible = false;
              }
            });
          } else if (this.type === 1) {
            // 编辑
            editLive(this.form).then((res) => {
              this.submitLoading = false;
              if (res.status === true) {
                this.$Message.success("操作成功");
                this.$parent.getDataList();
                this.drawerVisible = false;
              }
            });
          }
        }
      });
    },
    handleSelectUser(v) {
      this.form.lecturerId = v[0].id;
      this.selectUsers = v;
    },
    handelCancel() {
      this.drawerVisible = false;
    },
    handleUpload(v) {
      this.form.liveImage = v.fileUrl;
    },
  },
  mounted() {
    this.init();
  },
  watch: {},
};
</script>